module.exports = __webpack_public_path__ + "static/img/logo.afbd90e7.png";